import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24EditG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M15.247 3.049a1.556 1.556 0 0 1 2.201 0l3.993 3.993a1.556 1.556 0 0 1 0 2.201L9.678 21.006a1.56 1.56 0 0 1-1.02.454l-4.435.23a1.355 1.355 0 0 1-1.424-1.282l-.001-.089.232-4.487c.02-.385.182-.748.454-1.02zm-2.481 4.6-8.221 8.223a.06.06 0 0 0-.017.038l-.222 4.273 4.285-.223.026-.015 8.375-8.375-4.226-3.92zm3.622-3.54a.057.057 0 0 0-.08 0l-2.48 2.479 4.226 3.92 2.326-2.326c.015-.014.02-.035.015-.054l-.015-.026z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24EditG$1 = Svg24EditG;

export { Svg24EditG$1 as default };
